/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import {
  DEIPageLegendDIV,
  DEIPageLegendTypeDIV,
} from './DEIPageLegend.styles';

const DEIPageLegend = ({
  colors,
  filterLegend = false,
  onHoverType,
  types,
}) => (
  <DEIPageLegendDIV
    onMouseLeave={() => onHoverType(null)}
  >
    {types.map((type, i) => (filterLegend && (Number(type.percentage) === 0 || type.percentage === 'N/A')) ? null : (
      <DEIPageLegendTypeDIV
        className="font--text-M"
        key={type.title}
        onFocus={() => onHoverType(i)}
        onMouseOver={() => onHoverType(i)}
      >
        <img
          alt=""
          src={colors[i].PATTERN_S}
          role="presentation"
        />
        {type.title}
        <span className="font--blockquote-S">{type.percentage}{type.percentage !== 'N/A' ? '%' : ''}</span>
      </DEIPageLegendTypeDIV>
    ))}
  </DEIPageLegendDIV>
);

export default DEIPageLegend;
